import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "resultsContainer", "submitButton"]
  static values = { url: String, skipCheck: Boolean }

  intercept(event) {
    // If we already checked and user chose "create anyway", let the form submit
    if (this.skipCheckValue) return

    event.preventDefault()

    this._performSearch()
  }

  async _performSearch() {
    const form = this.formTarget
    const title = form.querySelector("[name='issue[title]']")?.value?.trim() || ""

    if (title.length < 5) {
      // Title too short, just submit normally (server validation will catch it)
      this.skipCheckValue = true
      form.requestSubmit()
      return
    }

    // Get description plain text from Trix editor
    const trixEditor = form.querySelector("trix-editor")
    const description = trixEditor?.editor?.getDocument()?.toString()?.trim() || ""

    const query = `${title} ${description}`.trim()

    // Get project_id from the select
    const projectId = form.querySelector("[name='issue[project_id]']")?.value || ""

    const params = new URLSearchParams({ query })
    if (projectId) {
      params.append("project_id", projectId)
    }

    // Show loading state on submit button
    const submitBtn = this.submitButtonTarget
    const originalHTML = submitBtn.innerHTML
    submitBtn.disabled = true
    submitBtn.innerHTML = `
      <svg class="animate-spin h-4 w-4 mr-1.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Checking for similar issues...
    `

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(`${this.urlValue}?${params}`, {
        headers: {
          "Accept": "text/html",
          "X-CSRF-Token": csrfToken
        }
      })

      if (response.ok) {
        const html = await response.text()
        const container = this.resultsContainerTarget
        container.innerHTML = html

        if (container.children.length > 0) {
          container.classList.remove("hidden")
          container.scrollIntoView({ behavior: "smooth", block: "center" })
        } else {
          // No similar issues found, submit the form
          this.skipCheckValue = true
          form.requestSubmit()
          return
        }
      } else {
        // API error, just submit the form
        this.skipCheckValue = true
        form.requestSubmit()
        return
      }
    } catch (error) {
      console.error("Similar issue search failed:", error)
      // On error, just submit the form
      this.skipCheckValue = true
      form.requestSubmit()
      return
    } finally {
      submitBtn.disabled = false
      submitBtn.innerHTML = originalHTML
    }
  }

  createAnyway() {
    this.skipCheckValue = true
    this.resultsContainerTarget.classList.add("hidden")
    this.formTarget.requestSubmit()
  }

  dismiss() {
    this.resultsContainerTarget.classList.add("hidden")
  }
}
